import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ElementRef, Renderer2, Input, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Navigation, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AulaOnlineService } from 'src/app/services/aula-online/aula-online.service';
import { MensagemRespostaComponent } from '../aula-online/minha-aula/questionario-online/questionario-online.component';
import { QuestionarioStateService } from '../aula-online/minha-aula/questionario-online/questionario-state.service';
import { PerguntaService } from 'src/app/services/aula-online/pergunta.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

interface MenuItem {
  image: string;
  text: string;
  url: string;
}

@Component({
  selector: 'app-aulas',
  templateUrl: './aulas.component.html',
  styleUrls: ['./aulas.component.scss'],

})
export class AulasComponent implements OnInit {
  @Input() pergunta;
  @Input() index;
  @ViewChild('radioBtn') radioBtn: ElementRef<HTMLInputElement>;

  respondeuTudo: boolean = true;
  hasClosedDialog: boolean = false;
  hasOpenDialog: boolean = false;
  respostasObservable: Subscription = null;

  perguntasLocal: any[] = null;
  tituloLocal: string = null;
  modalMsgResposta: boolean = false;
  refreshEvento: any = null;

  panelOpenState = false;
  isDesktop = false;
  videoUrl: SafeResourceUrl;

  respondeu: boolean = false;
  respondido: any = null;
  imgRespostas: any[] = [];
  respotasQuiz: any[] = [];

  selectedOption: boolean = false;

  menuItems: MenuItem[] = [
    { image: '../../../assets/home.png', text: 'Home', url:'initial' },
    { image: '../../../assets/minhas_aulas2.png', text: 'Minhas aulas', url:'disciplinas' },
    { image: '../../../assets/icon_simulados.png', text: 'Simulado', url:'simulados' },
    { image: '../../../assets/financeiro2.png', text: 'Financeiro', url:'alunos/matricula-aluno/aluno-financeiro-contrato' },
    { image: '../../../assets/documentos2.png', text: 'Documentos', url:'alunos/matricula-aluno/aluno-documentos' },
    { image: '../../../assets/conteudo.png', text: 'Conteúdo' , url:'alunos/matricula-aluno/conteudo-digital'},
    { image: '../../../assets/whatsapp_icon2.png', text: 'Canal WhatsApp', url:'whatsapp' },
    { image: '../../../assets/youtube2.png', text: 'YouTube', url: 'videos' },
    // { image: '../../../assets/eja_encceja2.png', text: 'Provas', url: 'alunos/eja-encceja' },
    { image: '../../../assets/sair.png', text: 'Sair', url: 'login' }
  ];

  aulas: any[] = [];
  matriculaId: number = null;
  videoId: number = null;
  materiaId: number = null;
  materias: any[] = [];
  selectedMateria: number = null;
  selectedAula: number = null;
  materiasUpper: any[] = [];
  isLoadingVideo: boolean = false;
  nomeAulaOnline: string = null;
  error: boolean = false;
  exercicios: any[] = null;
  anexoId: number = null;
  imgPergunta: any = null;
  imgPerguntaExtensao: string = 'image/png';
  aluno_: string = null;  
  isVideo: boolean = false;

  constructor(
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private aulaOnlineService: AulaOnlineService,
    private perguntaService: PerguntaService,
    private sanitizer: DomSanitizer,
    private questionarioStateService: QuestionarioStateService,
    private dialog: MatDialog,
    private renderer: Renderer2
  ) {
    const currentNavigation: Navigation = this.router.getCurrentNavigation();
   }

  ngOnInit() {
    this.aluno_ = window.localStorage.getItem('alunoStorage');
    if (this.aluno_) {
      const nomes = this.aluno_.split(" ");
      const primeiroNome = nomes[0];
      const ultimoNome = nomes[nomes.length - 1];
      this.aluno_ = primeiroNome + ' ' + ultimoNome;
    }


    this.breakpointObserver.observe(['(min-width: 768px)']).subscribe(result => {
      this.isDesktop = result.matches;
    });
    // (<HTMLInputElement>document.getElementById('carregamento')).style['visibility'] = 'visible';
    // const token = JSON.parse(window.localStorage.getItem('matricula'));
    this.anexoId = this.pergunta?.anexoId;
    this.matriculaId = Number(window.localStorage.getItem('matriculaIdLocalStorage'));
    this.materiaId = Number(window.localStorage.getItem('materiaIdStorage'));

    this.isVideo = window.localStorage.getItem('videosLocalStorage') == 'true' ? true : false;
    const materiaString = window.localStorage.getItem('materiaStorage');
    
    this.materias = JSON.parse(materiaString);
    for (let i = 0; i < this.materias.length; i++) {
      const materia = this.materias[i];
      const nomeMateriaUpper = materia.nomeMateria.toUpperCase();
      const materiaUpper = {
        id: materia.id,
        nomeMateria: nomeMateriaUpper
      };
      this.materiasUpper.push(materiaUpper);
    }

    this.selectedMateria = this.materiaId ;

    this.getAulas();
    
  }

  ngOnDestroy(): void {
    //this.questionarioStateService.completeAllSubjects();
    if(this.respostasObservable) this.respostasObservable.unsubscribe();
  }

  visualizaAula(aulaId: number): void{
    this.router.navigate(['/aulas'], { state: { aulaId } });
  }

  linkSeletor(url: string, aulaId: number): void {
    var cursoId = Number(window.localStorage.getItem('cursoIdLocalStorage'));
    switch (url) {
      case 'whatsapp':
        window.open("https://whatsapp.com/channel/0029Va56Dv72kNFxI2ufVE09");
        break;
      default:
        this.router.navigate([`/${url}`], { state: { aulaId } });
        break
    }
  }

  
getImgPergunta(anexoId: number, imgPerguntaExtensao: string ) {
    if(!anexoId || !imgPerguntaExtensao) return;
  this.perguntaService.getImg(anexoId, imgPerguntaExtensao).subscribe(val => {
    console.log(anexoId);
      this.imgPergunta = `data:${imgPerguntaExtensao};base64,${val}`;
    })
}
  
  getAulas() {
    
    return new Promise((res, rej) => {
      this.aulaOnlineService.minhasAulasOnline(this.materiaId).subscribe(val => {
        if (val?.status === 'error') {
          this.error = true;
          rej();
          return;
        }
        ;
        this.aulas = val.lista;
        this.selectedAula = this.aulas[0].id;
        this.videoId = this.selectedAula;
        this.getExercicios();
        this.getVideo(this.selectedAula);
        res(val);
        return;
      });
    });
  }

  getVideo(aulaOnLineId){
    this.aulaOnlineService.minhaVideoAulaOnline(aulaOnLineId).subscribe(val => {
      var new_url = val.urlVideo;
      new_url = new_url.substring(18, 255);
      new_url = new_url.substring(0, new_url.indexOf("/"));
      this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(`https://player.vimeo.com/video/${new_url}`);
    })
  }  
  
  getExercicios() {
    
    this.isLoadingVideo = true;
    return new Promise((res, rej) => {
      this.aulaOnlineService.meusExercicios(this.videoId).subscribe(val => {
        this.isLoadingVideo = false;
        if (val?.status === 'error') {
          this.error = true;
          rej();
          return;
        }
        const lista = val?.lista || [];
        this.exercicios = lista.map(item => ({
          ...item,
          arquivoString: this.normalizarDataUri(item?.arquivoString)
        }));
        this.imgRespostas = this.exercicios;
        res(val);
        return;
      });
    });
  }

  private normalizarDataUri(valor: string): string {
    if (!valor || !valor.startsWith('data:')) {
      return valor;
    }

    const match = valor.match(/^data:([^;]+);base64,/i);
    if (!match || !match[1]) {
      return valor;
    }

    const tipoOriginal = match[1].trim().toLowerCase();
    if (tipoOriginal.includes('/')) {
      return valor;
    }

    const token = tipoOriginal.replace('.', '').replace('_', '');
    const mapaMime = {
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      gif: 'image/gif',
      bmp: 'image/bmp',
      webp: 'image/webp',
      svg: 'image/svg+xml',
      heic: 'image/heic',
      tiff: 'image/tiff',
      dng: 'image/x-adobe-dng',
      pdf: 'application/pdf',
      txt: 'text/plain',
      html: 'text/html',
      css: 'text/css',
      xml: 'text/xml',
      mp4: 'video/mp4',
      zip: 'application/zip',
      doc: 'application/msword',
      docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      xls: 'application/vnd.ms-excel',
      xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      exe: 'application/x-msdownload'
    } as { [key: string]: string };

    const mime = mapaMime[token];
    if (!mime) {
      return valor;
    }

    return valor.replace(/^data:[^;]+;base64,/i, `data:${mime};base64,`);
  }

  opcaoSelecionada(event) {
    this.materiaId = event.value;
    this.getAulas();
  }

  opcaoAulaSelecionada(event) {
    this.videoId = event.value;
    this.getExercicios();
    this.getVideo(this.videoId);
  }

  opcaoVideoSelecionado(videoId: number) {
    this.getVideo(videoId);
  }

  refazer() {
    var radios = document.querySelectorAll('input[type="radio"]') as NodeListOf<HTMLInputElement>;
    for (var i = 0; i < radios.length; i++) {
      radios[i].checked = false;
      
      (radios[i].parentNode as HTMLElement).classList.remove('bg-light-red');
      (radios[i].parentNode as HTMLElement).classList.remove('bg-light-green');

      const divIconCorreto =  radios[i].parentNode.querySelector('#icon-correto');
      const divIconErrado =  radios[i].parentNode.querySelector('#icon-errado');
      divIconCorreto.classList.remove('ng-show');
      divIconErrado.classList.remove('ng-show');

    }

    this.respondeuTudo = false;
    this.hasOpenDialog = false;
    this.questionarioStateService.respondeuNext(false);
    this.questionarioStateService.respostaNext([]);
    if(this.respostasObservable != null)
      this.respostasObservable.unsubscribe();
  }

  
   showMensagemResposta(percentage, text, icon) {
    this.hasClosedDialog = false;
    this.hasOpenDialog = true;
    const dialogRef = this.dialog.open(MensagemRespostaComponent, {
      autoFocus: false,
      data: { percentage,text, icon },
    });

    dialogRef.afterClosed().subscribe(result => {

      this.hasClosedDialog = true;
      this.hasOpenDialog = false;
    });
  }

  showImgResposta(resposta): void {
    
    if(!(this.imgRespostas?.length > 0) || !resposta) return;
    const { id } = resposta
    if(!id) return;
    const img = this.imgRespostas.find(elem => elem?.id === id);
    return img ? img.img : null;
  }

  
  verificarRespostas() {
    var acertadas = 0;
    const form = document.getElementById('quiz-form');
    const questions = form.querySelectorAll('input[type="radio"]');
    questions.forEach((question) => {
      const inputRadio = document.getElementById(`${question.id}`) as HTMLInputElement;
      const divIconCorreto = inputRadio.parentNode.querySelector('#icon-correto');
      const divIconErrado = inputRadio.parentNode.querySelector('#icon-errado');
      divIconCorreto.classList.add('ng-hide');
      divIconErrado.classList.add('ng-hide');


      if (inputRadio.getAttribute('data-resposta') == 'true') {
        (inputRadio.parentNode as HTMLElement).classList.add('bg-light-green');
        (inputRadio.parentNode as HTMLElement).classList.remove('bg-light-red');
        divIconCorreto.classList.add('ng-show')
        acertadas += 1;
      } else {
        if (inputRadio.checked) {
          (inputRadio.parentNode as HTMLElement).classList.add('bg-light-red');
          (inputRadio.parentNode as HTMLElement).classList.remove('bg-light-green');
          divIconErrado.classList.add('ng-show')
          acertadas -= 1;
        }
      }
    });

     const mediaAcertos = acertadas / this.exercicios.length;

      if(mediaAcertos === 1) this.showMensagemResposta(mediaAcertos, 'Parabéns, excelente resultado! Nota 10.', 'insert_emoticon');
      else if(mediaAcertos >= 0.7 && mediaAcertos <= 0.99) this.showMensagemResposta(mediaAcertos, 'Parabéns, você esta indo muito bem!', 'sentiment_satisfied_alt');
      else if(mediaAcertos >= 0.5 && mediaAcertos <= 0.69) this.showMensagemResposta(mediaAcertos, 'Você esta indo bem, continue estudando!', 'sentiment_satisfied');
      else if(mediaAcertos >= 0.2 && mediaAcertos <= 0.49) this.showMensagemResposta(mediaAcertos, 'Você esta quase lá, continue estudando.', 'sentiment_dissatisfied');
      else this.showMensagemResposta(mediaAcertos,'Você esta quase lá, tente novamente!', 'sentiment_very_dissatisfied');
  }
}

